import { HighlightType, HIGHLIGHT_CONFIG, getHighlightLabel } from '@/utils/highlights';
import { PlanType } from '@/config/api';
import './HighlightBadge.scss';

interface HighlightBadgeProps {
  type: HighlightType;
  planType?: PlanType;
}

export function HighlightBadge({ type, planType }: HighlightBadgeProps) {
  const config = HIGHLIGHT_CONFIG[type];
  const label = getHighlightLabel(type, planType);
  return (
    <div className={`highlight-badge ${config.className}`}>
      {label}
    </div>
  );
}
